import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

import { AuthGuard } from './auth/auth.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full'
  },
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.module').then(m => m.AuthPageModule)
  },
  {
    path: 'info',
    loadChildren: () => import('./info/info.module').then(m => m.InfoPageModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'dashboard',
    children: [
      {
        path: '',
        loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardPageModule),
        canLoad: [AuthGuard],
        pathMatch: 'full'
      },
      {
        path: 'day',
        children: [
          {
            path: '',
            loadChildren: () => import('./dashboard/day/day.module').then(m => m.DayPageModule),
            canLoad: [AuthGuard],
            pathMatch: 'full'
          },
          {
            path: 'relations',
            loadChildren: () => import('./relations/relations/relations.module').then(m => m.RelationsPageModule),
            canLoad: [AuthGuard]
          },
          {
            path: 'notes',
            loadChildren: () => import('./notes/notes/notes.module').then(m => m.NotesPageModule),
            canLoad: [AuthGuard]
          },
          {
            path: 'mails',
            loadChildren: () => import('./mails/mails/mails.module').then(m => m.MailsPageModule),
            canLoad: [AuthGuard]
          },
          {
            path: 'sales-invoices',
            loadChildren: () => import('./sales-invoices/sales-invoices/sales-invoices.module').then(m => m.SalesInvoicesPageModule),
            canLoad: [AuthGuard]
          },
          {
            path: 'sales-credit-notes',
            loadChildren: () => import('./sales-invoices/sales-credit-notes/sales-credit-notes.module').then(m => m.SalesCreditNotesPageModule),
            canLoad: [AuthGuard]
          },
          {
            path: 'quotations',
            loadChildren: () => import('./quotations/quotations/quotations.module').then(m => m.QuotationsPageModule),
            canLoad: [AuthGuard]
          },
          {
            path: 'delivery-notes',
            loadChildren: () => import('./delivery-notes/delivery-notes/delivery-notes.module').then(m => m.DeliveryNotesPageModule),
            canLoad: [AuthGuard]
          },
          {
            path: 'customer-orders',
            loadChildren: () => import('./customer-orders/customer-orders/customer-orders.module').then(m => m.CustomerOrdersPageModule),
            canLoad: [AuthGuard]
          },
          {
            path: 'work-orders',
            children: [
              {
                path: ':id',
                loadChildren: () => import('./work-orders/work-orders/work-orders.module').then(m => m.WorkOrdersPageModule),
                canLoad: [AuthGuard]
              }
            ]
          },
          {
            path: 'sales-opportunities',
            loadChildren: () => import('./sales-opportunities/sales-opportunities/sales-opportunities.module').then(m => m.SalesOpportunitiesPageModule),
            canLoad: [AuthGuard]
          },
          {
            path: 'sales-payments',
            loadChildren: () => import('./sales-payments/sales-payments/sales-payments.module').then(m => m.SalesPaymentsPageModule),
            canLoad: [AuthGuard]
          },
          {
            path: 'purchase-orders',
            loadChildren: () => import('./purchase-orders/purchase-orders/purchase-orders.module').then(m => m.PurchaseOrdersPageModule),
            canLoad: [AuthGuard]
          },
          {
            path: 'purchase-invoices',
            loadChildren: () => import('./purchase-invoices/purchase-invoices/purchase-invoices.module').then(m => m.PurchaseInvoicesPageModule),
            canLoad: [AuthGuard]
          },
          {
            path: 'purchase-credit-notes',
            loadChildren: () => import('./purchase-invoices/purchase-credit-notes/purchase-credit-notes.module').then(m => m.PurchaseCreditNotesPageModule),
            canLoad: [AuthGuard]
          },
          {
            path: 'preliminary-customer-orders',
            loadChildren: () => import('./preliminary-customer-orders/preliminary-customer-orders/preliminary-customer-orders.module').then(m => m.PreliminaryCustomerOrdersPageModule),
            canLoad: [AuthGuard]
          }
        ]
      },
      {
        path: 'outstanding-notes',
        children: [
          {
            path: '',
            loadChildren: () => import('./dashboard/outstanding-notes/outstanding-notes.module').then(m => m.OutstandingNotesPageModule),
            canLoad: [AuthGuard],
            pathMatch: 'full'
          },
          {
            path: ':id',
            loadChildren: () => import('./notes/notes/notes.module').then(m => m.NotesPageModule),
            canLoad: [AuthGuard]
          }
        ]
      },
      {
        path: 'outstanding-mails',
        children: [
          {
            path: '',
            loadChildren: () => import('./dashboard/outstanding-mails/outstanding-mails.module').then(m => m.OutstandingMailsPageModule),
            canLoad: [AuthGuard],
            pathMatch: 'full'
          },
          {
            path: ':id',
            loadChildren: () => import('./mails/mails/mails.module').then(m => m.MailsPageModule),
            canLoad: [AuthGuard]
          }
        ]
      },
      {
        path: 'outstanding-sales-invoices',
        children: [
          {
            path: '',
            loadChildren: () => import('./dashboard/outstanding-sales-invoices/outstanding-sales-invoices.module').then(m => m.OutstandingSalesInvoicesPageModule),
            canLoad: [AuthGuard],
            pathMatch: 'full'
          },
          {
            path: ':id',
            loadChildren: () => import('./sales-invoices/sales-invoices/sales-invoices.module').then(m => m.SalesInvoicesPageModule),
            canLoad: [AuthGuard]
          }
        ]
      },
      {
        path: 'outstanding-quotations-employee',
        children: [
          {
            path: '',
            // tslint:disable-next-line: max-line-length
            loadChildren: () => import('./dashboard/outstanding-quotations-employees/outstanding-quotations-employees.module').then(m => m.OutstandingQuotationsEmployeesPageModule),
            canLoad: [AuthGuard],
            pathMatch: 'full'
          },
          {
            path: ':employeeId',
            loadChildren: () => import('./quotations/quotations/quotations.module').then(m => m.QuotationsPageModule),
            canLoad: [AuthGuard]
          }
        ]
      },
      {
        path: 'outstanding-quotations-status',
        children: [
          {
            path: '',
            // tslint:disable-next-line: max-line-length
            loadChildren: () => import('./dashboard/outstanding-quotations-status/outstanding-quotations-status.module').then(m => m.OutstandingQuotationsStatusPageModule),
            canLoad: [AuthGuard],
            pathMatch: 'full'
          },
          {
            path: ':statusId',
            loadChildren: () => import('./quotations/quotations/quotations.module').then(m => m.QuotationsPageModule),
            canLoad: [AuthGuard]
          }
        ]
      },
      {
        path: 'outstanding-customer-orders',
        children: [
          {
            path: '',
            loadChildren: () => import('./dashboard/outstanding-customer-orders/outstanding-customer-orders.module').then(m => m.OutstandingCustomerOrdersPageModule),
            canLoad: [AuthGuard],
            pathMatch: 'full'
          },
          {
            path: ':id',
            loadChildren: () => import('./customer-orders/customer-orders/customer-orders.module').then(m => m.CustomerOrdersPageModule),
            canLoad: [AuthGuard]
          }
        ]
      },
      {
        path: 'outstanding-work-orders',
        children: [
          {
            path: '',
            loadChildren: () => import('./dashboard/outstanding-work-orders/outstanding-work-orders.module').then(m => m.OutstandingWorkOrdersPageModule),
            canLoad: [AuthGuard],
            pathMatch: 'full'
          },
          {
            path: ':employeeId',
            loadChildren: () => import('./work-orders/work-orders/work-orders.module').then(m => m.WorkOrdersPageModule),
            canLoad: [AuthGuard]
          }
        ]
      },
      {
        path: 'active-work-orders',
        children: [
          {
            path: '',
            loadChildren: () => import('./dashboard/active-work-orders/active-work-orders.module').then(m => m.ActiveWorkOrdersPageModule),
            canLoad: [AuthGuard],
            pathMatch: 'full'
          },
          {
            path: ':statusIndex',
            loadChildren: () => import('./work-orders/work-orders/work-orders.module').then(m => m.WorkOrdersPageModule),
            canLoad: [AuthGuard]
          }
        ]
      },
      {
        path: 'outstanding-sales-opportunities',
        children: [
          {
            path: '',
            // tslint:disable-next-line: max-line-length
            loadChildren: () => import('./dashboard/outstanding-sales-opportunities/outstanding-sales-opportunities.module').then(m => m.OutstandingSalesOpportunitiesPageModule),
            canLoad: [AuthGuard],
            pathMatch: 'full'
          },
          {
            path: ':id',
            loadChildren: () => import('./sales-opportunities/sales-opportunities/sales-opportunities.module').then(m => m.SalesOpportunitiesPageModule),
            canLoad: [AuthGuard]
          }
        ]
      },
      {
        path: 'outstanding-preliminary-customer-orders',
        children: [
          {
            path: '',
            loadChildren: () => import('./dashboard/outstanding-preliminary-customer-orders/outstanding-preliminary-customer-orders.module').then(m => m.OutstandingPreliminaryCustomerOrdersPageModule),
            canLoad: [AuthGuard],
            pathMatch: 'full'
          },
          {
            path: ':id',
            loadChildren: () => import('./preliminary-customer-orders/preliminary-customer-orders/preliminary-customer-orders.module').then(m => m.PreliminaryCustomerOrdersPageModule),
            canLoad: [AuthGuard]
          }
        ]
      },
      {
        path: 'annual-sales',
        loadChildren: () => import('./dashboard/annual-sales/annual-sales.module').then(m => m.AnnualSalesPageModule),
        canLoad: [AuthGuard]
      },
      {
        path: 'monthly-sales',
        loadChildren: () => import('./dashboard/monthly-sales/monthly-sales.module').then(m => m.MonthlySalesPageModule),
        canLoad: [AuthGuard]
      }
    ]
  },
  {
    path: 'dashboard/outstanding-purchase-invoices',
    loadChildren: () => import('./dashboard/outstanding-purchase-invoices/outstanding-purchase-invoices.module').then(m => m.OutstandingPurchaseInvoicesPageModule),
    canLoad: [AuthGuard]
  },
  {
    path: 'notes',
    children: [
      {
        path: ':id',
        loadChildren: () => import('./notes/note-detail/note-detail.module').then(m => m.NoteDetailPageModule),
        canLoad: [AuthGuard]
      }
    ]
  },
  {
    path: 'mails',
    children: [
      {
        path: ':computer/:relation/:entry',
        loadChildren: () => import('./mails/mail-detail/mail-detail.module').then(m => m.MailDetailPageModule),
        canLoad: [AuthGuard]
      }
    ]
  },
  {
    path: 'sales-invoices',
    children: [
      {
        path: ':id',
        loadChildren: () => import('./sales-invoices/sales-invoice-detail/sales-invoice-detail.module').then(m => m.SalesInvoiceDetailPageModule),
        canLoad: [AuthGuard]
      }
    ]
  },
  {
    path: 'quotations',
    children: [
      {
        path: ':id',
        loadChildren: () => import('./quotations/quotation-detail/quotation-detail.module').then(m => m.QuotationDetailPageModule),
        canLoad: [AuthGuard]
      }
    ]
  },
  {
    path: 'delivery-notes',
    children: [
      {
        path: ':id',
        loadChildren: () => import('./delivery-notes/delivery-note-detail/delivery-note-detail.module').then(m => m.DeliveryNoteDetailPageModule),
        canLoad: [AuthGuard]
      }
    ]
  },
  {
    path: 'customer-orders',
    children: [
      {
        path: ':id',
        loadChildren: () => import('./customer-orders/customer-order-detail/customer-order-detail.module').then(m => m.CustomerOrderDetailPageModule),
        canLoad: [AuthGuard]
      }
    ]
  },
  {
    path: 'work-orders',
    children: [
      {
        path: ':id',
        loadChildren: () => import('./work-orders/work-order-detail/work-order-detail.module').then(m => m.WorkOrderDetailPageModule),
        canLoad: [AuthGuard]
      }
    ]
  },
  {
    path: 'sales-opportunities',
    children: [
      {
        path: ':id',
        loadChildren: () => import('./sales-opportunities/sales-opportunity-detail/sales-opportunity-detail.module').then(m => m.SalesOpportunityDetailPageModule),
        canLoad: [AuthGuard]
      }
    ]
  },
  {
    path: 'sales-payments',
    children: [
      {
        path: ':id/:methodIndex/:paymentIndex',
        loadChildren: () => import('./sales-payments/sales-payment-detail/sales-payment-detail.module').then(m => m.SalesPaymentDetailPageModule),
        canLoad: [AuthGuard]
      }
    ]
  },
  {
    path: 'relations',
    children: [
      {
        path: ':id',
        loadChildren: () => import('./relations/relation-detail/relation-detail.module').then(m => m.RelationDetailPageModule),
        canLoad: [AuthGuard]
      },
      {
        path: 'address',
        children: [
          {
            path: ':relation/:id',
            loadChildren: () => import('./relations/relation-detail/address-detail/address-detail.module').then(m => m.AddressDetailPageModule),
            canLoad: [AuthGuard]
          }
        ]
      }
    ]
  },
  {
    path: 'preliminary-customer-orders',
    children: [
      {
        path: ':id',
        loadChildren: () => import('./preliminary-customer-orders/preliminary-customer-order-detail/preliminary-customer-order-detail.module').then(m => m.PreliminaryCustomerOrderDetailPageModule),
        canLoad: [AuthGuard]
      }
    ]
  }
  // {
  //   path: 'address-detail',
  //   loadChildren: () => import('./relations/relation-detail/address-detail/address-detail.module').then( m => m.AddressDetailPageModule)
  // }

  // {
  //   path: 'outstanding-customer-orders',
  //   children: [
  //     {
  //       path: '',
  //       loadChildren: './dashboard/outstanding-customer-orders/outstanding-customer-orders.module#OutstandingCustomerOrdersPageModule',
  //       canLoad: [AuthGuard],
  //       pathMatch: 'full'
  //     },
  //     {
  //       path: ':id',
  //       loadChildren: './customer-orders/customer-orders/customer-orders.module#CustomerOrdersPageModule',
  //       canLoad: [AuthGuard]
  //     }
  //   ]
  // }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
